// extracted by mini-css-extract-plugin
module.exports = {"genrelist":"App_genrelist__pOaxt","genre_btn":"App_genre_btn__3HZWv","movie":"App_movie__2a2Nd","movie_desc":"App_movie_desc__3ayLX"};